/** @file Thai catalog part of area E2 (W3-03), partial; replaced whole by that area. */

/** The `forms` block (CommandForm, delete dialog, tree panels); partial, English fills the gaps. S0 composes it into `th`. */
export const formsTh = {
  apply: 'ใช้', set: 'กำหนด {field}', invalidJson: 'ไม่ใช่ JSON ที่ถูกต้อง', noProject: 'ยังไม่ได้เปิดโปรเจกต์',
  color: { pick: 'เลือกสี', alpha: 'ความทึบ' },
  delete: { one: 'ลบ {name}?', many: 'ลบ {n} รายการ?', alsoRemoves: 'จะลบสิ่งเหล่านี้ไปด้วย:' },
  kinds: {
    image: 'รูปภาพ {n} รายการ', bone: 'bone {n} ชิ้น', slot: 'slot {n} ช่อง', attachment: 'attachment {n} รายการ', skin: 'skin {n} ชุด',
    ik: 'IK {n} ชุด', event: 'event {n} รายการ', socket: 'socket {n} จุด', animation: 'animation {n} รายการ', reference: 'ภาพอ้างอิง {n} ภาพ',
  },
} as const;
